import { AiOutlineUser } from "react-icons/ai";
import { MdBrowserNotSupported, MdMonitor, MdInsights, MdSettingsSuggest } from "react-icons/md";

// Page Title: miniOrange AI Agent Studio Demo
export const aiAgentStudioData = [
    {
        title: "AI-Powered Automation",
        video: false,
        videoId: "",
        videoType: "",
        icon: <AiOutlineUser className='text-white fs-5' />
    },
    {
        title: "Insights & Continuous Learning",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdInsights className='text-white fs-5' />
    },
    {
        title: "Customizable Agent Behavior",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdSettingsSuggest className='text-white fs-5' />
    },
    {
        title: "Context-Aware Interactions",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdBrowserNotSupported className='text-white fs-5' />
    },
    {
        title: "Seamless Integration Support",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdMonitor className='text-white fs-5' />
    }
]